const PERSISTENCE_FIELDS = new Set(["updated_at", "source_kind", "source_label"]);

// A matrix row is saved sequentially; Dispatch must only see the final profile.
export async function saveCompartmentTruckChanges(truckId, { truckPayload, compartmentMutations }, api) {
  let result = null;
  let savedCount = 0;
  const changedFields = new Set();
  const captureAudits = [];
  try {
    if (truckPayload) {
      result = await api.updateTruck(truckId, truckPayload);
      if (result?.audit) captureAudits.push(result.audit);
      savedCount += 1;
      for (const field of result?.audit?.changed_fields ?? ["truck"]) changedFields.add(field);
    }
    for (const { action, compartmentId, payload } of compartmentMutations) {
      if (action === "create") result = await api.createCompartment(truckId, payload);
      else if (action === "update") result = await api.updateCompartment(truckId, compartmentId, payload);
      else if (action === "delete") result = await api.deleteCompartment(truckId, compartmentId, payload);
      else throw new Error("Modification de compartiment inconnue.");
      if (result?.audit) captureAudits.push(result.audit);
      savedCount += 1;
      const fields = result?.audit?.changed_fields;
      if (action !== "update" || !Array.isArray(fields) || fields.some((field) => !PERSISTENCE_FIELDS.has(field))) {
        changedFields.add("compartments");
      }
    }
  } catch (error) {
    const message = savedCount > 0
      ? `${savedCount} modification(s) enregistrée(s), mais la ligne n’a pas pu être entièrement sauvegardée.`
      : "La sauvegarde de la ligne n’a pas pu être confirmée.";
    const saveError = new Error(`${message} ${error?.message || "Vérifiez les données rechargées avant de réessayer."}`, { cause: error });
    saveError.confirmedWriteCount = savedCount;
    saveError.captureAudits = captureAudits;
    throw saveError;
  }
  return {
    ...result,
    captureAudits,
    audit: { ...result?.audit, changed_fields: [...changedFields] },
    message: "Compartiments enregistrés.",
  };
}
